// removed by extract-text-webpack-plugin
module.exports = {"h4":"H4__h4___3s8l5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/H4.scss
// module id = j/aI
// module chunks = 0